import { render, staticRenderFns } from "./shop-purchase-book.vue?vue&type=template&id=4125af27&scoped=true&"
import script from "./shop-purchase-book.vue?vue&type=script&lang=js&"
export * from "./shop-purchase-book.vue?vue&type=script&lang=js&"
import style0 from "./shop-purchase-book.vue?vue&type=style&index=0&id=4125af27&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4125af27",
  null
  
)

export default component.exports